var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20028,
    height: 32769,
    viewBox: "0 0 20028 32769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_25923)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6632.96 21445.3L8672.85 20808.8L8201.65 19185.5L9911.15 17097.3L11325.8 18255.3L12787.1 16470.2L11675.8 14941.6L7856.92 14178L6186.69 18211.1L6632.96 21445.3Z",
    fill: "#0041ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_25923",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6186,
    y: 14178,
    width: 6602,
    height: 7268
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6632.96 21445.3L8672.85 20808.8L8201.65 19185.5L9911.15 17097.3L11325.8 18255.3L12787.1 16470.2L11675.8 14941.6L7856.92 14178L6186.69 18211.1L6632.96 21445.3Z",
    fill: "#0041ED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_25923)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9043.25 16392.5L6042 20640.3L6474.86 20903.7L10826.6 14728.3L10411.9 14437.8L9061.47 16365.4",
    fill: "#FF600F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8781.89 15559.8L8757.22 15554.4L8735.96 15568L8614.27 15541.5L8593.83 15554.6L8574.58 15643L8474.77 15621.2L8494.02 15532.9L8480.91 15512.4L8359.21 15485.9L8345.57 15464.7L8320.9 15459.3L8299.64 15472.9L8294.27 15497.6L8307.92 15518.8L8238.45 15837.5L8283.64 15847.4L8220.67 16136.2L8199.43 16149.9L8194.06 16174.5L8207.68 16195.8L8232.37 16201.2L8253.61 16187.5L8330.52 16204.3L8350.97 16191.2L8360.98 16145.2L8460 16166.8L8449.97 16212.7L8463.11 16233.2L8540.02 16249.9L8553.67 16271.2L8578.33 16276.6L8599.57 16262.9L8604.96 16238.3L8591.31 16217L8654.27 15928.1L8699.45 15938L8768.9 15619.3L8790.16 15605.7L8795.53 15581L8781.89 15559.8Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8003.69 15855.7L7930.22 15839.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7996.97 15886.6L7923.49 15870.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7990.21 15917.5L7916.74 15901.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7983.46 15948.4L7910.01 15932.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7976.73 15979.4L7903.26 15963.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7969.98 16010.3L7896.51 15994.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7963.25 16041.2L7889.78 16025.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7956.5 16072.2L7883.03 16056.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7949.77 16103.1L7876.29 16087.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7943.02 16134L7869.55 16118",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8090.15 15459L8016.68 15443",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8083.41 15490L8009.93 15473.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8076.67 15520.9L8003.2 15504.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8069.92 15551.8L7996.45 15535.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8063.17 15582.7L7989.71 15566.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8056.45 15613.7L7982.97 15597.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8049.69 15644.6L7976.23 15628.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8042.96 15675.5L7969.48 15659.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8036.21 15706.5L7962.74 15690.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8029.48 15737.4L7956 15721.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8137.66 15884.9L8096.68 15875.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8130.93 15915.8L8089.95 15906.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8124.18 15946.7L8083.2 15937.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8117.43 15977.6L8076.45 15968.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8110.7 16008.6L8069.72 15999.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8103.95 16039.5L8062.97 16030.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8097.22 16070.4L8056.24 16061.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8090.46 16101.4L8049.49 16092.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8083.73 16132.3L8042.76 16123.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8076.98 16163.2L8036.01 16154.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8224.11 15488.2L8183.14 15479.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8217.37 15519.1L8176.4 15510.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8210.63 15550.1L8169.66 15541.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8203.89 15581L8162.91 15572.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8197.13 15611.9L8156.18 15603",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8190.41 15642.9L8149.43 15633.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8183.65 15673.8L8142.67 15664.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8176.92 15704.7L8135.95 15695.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8170.18 15735.7L8129.2 15726.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8163.44 15766.6L8122.46 15757.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8821.91 16034L8780.93 16025.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8815.16 16064.9L8774.18 16056",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8808.43 16095.8L8767.45 16086.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8801.68 16126.8L8760.7 16117.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8794.95 16157.7L8753.97 16148.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8788.2 16188.6L8747.22 16179.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8781.44 16219.6L8740.46 16210.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8774.71 16250.5L8733.74 16241.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8767.97 16281.4L8726.99 16272.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8761.24 16312.4L8720.26 16303.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8908.36 15637.4L8867.4 15628.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8901.62 15668.3L8860.64 15659.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8894.87 15699.2L8853.89 15690.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8888.13 15730.1L8847.16 15721.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8881.39 15761.1L8840.41 15752.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8874.65 15792L8833.68 15783.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8867.9 15822.9L8826.93 15814",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8861.16 15853.9L8820.2 15844.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8854.42 15884.8L8813.44 15875.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8847.67 15915.7L8806.7 15906.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9031.49 15664.2L8990.53 15655.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9024.76 15695.1L8983.78 15686.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9018.01 15726.1L8977.03 15717.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9011.27 15757L8970.3 15748.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9004.53 15787.9L8963.55 15779",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8997.79 15818.9L8956.81 15809.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8991.05 15849.8L8950.07 15840.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8984.3 15880.7L8943.34 15871.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8977.56 15911.7L8936.59 15902.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8970.82 15942.6L8929.84 15933.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9293.76 15591.8L9252.78 15582.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9287.02 15622.7L9246.05 15613.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9280.27 15653.6L9239.3 15644.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9273.54 15684.6L9232.57 15675.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9266.79 15715.5L9225.82 15706.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9260.04 15746.4L9219.06 15737.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9253.31 15777.3L9212.34 15768.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9246.56 15808.3L9205.58 15799.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9239.83 15839.2L9198.85 15830.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7915.39 16260.7L7841.92 16244.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7908.66 16291.7L7835.19 16275.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7901.92 16322.6L7828.44 16306.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7895.19 16353.5L7821.71 16337.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7888.43 16384.5L7814.96 16368.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7881.69 16415.4L7808.23 16399.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7874.95 16446.3L7801.48 16430.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7868.21 16477.2L7794.75 16461.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8186.22 16319.8L8145.24 16310.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8179.47 16350.7L8138.5 16341.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8172.74 16381.6L8131.76 16372.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8165.99 16412.6L8125.02 16403.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8159.26 16443.5L8118.28 16434.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8152.51 16474.4L8111.53 16465.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8145.77 16505.4L8104.8 16496.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8139.02 16536.3L8098.05 16527.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8323.06 16349.6L8282.08 16340.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8316.31 16380.5L8275.33 16371.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8309.58 16411.5L8268.6 16402.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8302.83 16442.4L8261.85 16433.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8296.08 16473.3L8255.12 16464.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8289.35 16504.2L8248.37 16495.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8282.6 16535.2L8241.63 16526.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8275.87 16566.1L8234.89 16557.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8459.91 16379.4L8418.95 16370.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8453.18 16410.4L8412.2 16401.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8446.42 16441.3L8405.44 16432.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8439.7 16472.2L8398.72 16463.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8432.94 16503.1L8391.97 16494.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8426.21 16534.1L8385.24 16525.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8419.47 16565L8378.49 16556.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8412.71 16595.9L8371.75 16587",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8596.75 16409.2L8555.77 16400.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8590.02 16440.2L8549.04 16431.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8583.27 16471.1L8542.29 16462.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8576.55 16502L8535.57 16493.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8569.79 16533L8528.81 16524",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8563.04 16563.9L8522.06 16555",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8556.31 16594.8L8515.33 16585.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8549.56 16625.7L8508.58 16616.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8733.61 16439.1L8692.63 16430.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8726.86 16470L8685.88 16461.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8720.13 16500.9L8679.15 16492",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8713.38 16531.9L8672.4 16522.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8706.64 16562.8L8665.67 16553.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8699.9 16593.7L8658.92 16584.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8693.16 16624.6L8652.18 16615.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8686.42 16655.6L8645.44 16646.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9019.62 16238.4L8985.27 16214.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9001.48 16264.4L8967.12 16240.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8983.3 16290.3L8948.96 16266.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8965.15 16316.2L8930.8 16292.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8947 16342.2L8912.64 16318.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8928.85 16368.1L8894.49 16344.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8910.69 16394L8876.34 16370",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8892.54 16420L8858.19 16395.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8874.39 16445.9L8840.03 16421.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9164.71 16031.2L9130.35 16007.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9146.55 16057.1L9112.19 16033.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9128.4 16083.1L9094.05 16059",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9110.22 16109L9075.87 16085",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9092.08 16134.9L9057.73 16110.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9073.92 16160.9L9039.56 16136.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9055.78 16186.8L9021.43 16162.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9037.62 16212.7L9003.26 16188.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8049.36 16289.9L8008.39 16281",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8042.63 16320.9L8001.65 16311.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8035.88 16351.8L7994.91 16342.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8029.15 16382.7L7988.17 16373.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8022.4 16413.7L7981.43 16404.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8015.65 16444.6L7974.68 16435.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8008.92 16475.5L7967.94 16466.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8002.17 16506.5L7961.19 16497.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8140.32 15228.9L8066.86 15212.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8133.6 15259.8L8060.12 15243.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8126.85 15290.7L8053.37 15274.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8120.11 15321.7L8046.64 15305.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8113.36 15352.6L8039.89 15336.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8417.88 15257L8376.9 15248",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8411.13 15287.9L8370.15 15279",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8404.4 15318.8L8363.42 15309.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8397.65 15349.8L8356.67 15340.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8390.89 15380.7L8349.92 15371.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8384.16 15411.6L8343.19 15402.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8554.72 15286.8L8513.75 15277.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8547.99 15317.7L8507.01 15308.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8541.23 15348.7L8500.26 15339.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8534.51 15379.6L8493.53 15370.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8527.76 15410.5L8486.78 15401.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8521.03 15441.5L8480.05 15432.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8691.56 15316.6L8650.58 15307.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8684.82 15347.6L8643.84 15338.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8678.08 15378.5L8637.1 15369.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8671.33 15409.4L8630.37 15400.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8664.59 15440.4L8623.61 15431.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8657.85 15471.3L8616.87 15462.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8828.41 15346.4L8787.43 15337.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8821.66 15377.4L8780.68 15368.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8814.93 15408.3L8773.95 15399.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8808.18 15439.2L8767.2 15430.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8801.44 15470.2L8760.47 15461.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8794.7 15501.1L8753.72 15492.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8965.26 15376.3L8924.29 15367.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8958.51 15407.2L8917.53 15398.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8951.78 15438.1L8910.8 15429.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8945.03 15469.1L8904.05 15460.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8938.28 15500L8897.3 15491.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8931.55 15530.9L8890.57 15522",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9086.35 15402.7L9045.38 15393.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9079.6 15433.6L9038.63 15424.7",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9072.87 15464.5L9031.9 15455.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9066.12 15495.5L9025.14 15486.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9059.39 15526.4L9018.41 15517.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9052.64 15557.3L9011.66 15548.4",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8281.02 15227.1L8240.04 15218.2",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8274.26 15258.1L8233.29 15249.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8267.53 15289L8226.56 15280.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8260.78 15319.9L8219.81 15311",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8254.05 15350.9L8213.07 15341.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8247.3 15381.8L8206.33 15372.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9147.55 16425.7L6245.49 20492.1L6488.05 20662L10740.6 14668.1L10498 14498.1L9147.55 16425.7Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6390.13 20585.9L10628.2 14589.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7876.25 18607.8L7880.3 18602.1",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6455.42 20607.7L10699.5 14624.6",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10,
    strokeDasharray: "22.39 44.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10707.6 14613.2L10711.7 14607.5",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7752.49 18520L7756.53 18514.3",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6303.11 20585.9L10575.8 14536.9",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10,
    strokeDasharray: "22.39 44.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10583.9 14525.5L10587.9 14519.8",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9312.73 16006.8L9430.66 15465.7C9449.31 15380.2 9395.07 15295.7 9309.51 15277.1L8164.97 15027.6C8079.42 15009 7994.94 15063.2 7976.31 15148.8L7687.81 16472.4C7669.16 16558 7723.39 16642.5 7808.95 16661.1L8715.85 16858.8L9312.75 16006.8H9312.73Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8901 16056.1L8853.02 16276.2C8850.48 16287.9 8865.99 16294.3 8872.46 16284.3L9003.3 16082.3C9007.36 16076 9003.9 16067.6 8996.6 16066L8913.75 16047.9C8907.98 16046.7 8902.27 16050.3 8901.02 16056.1H8901Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9144.42 15678.2L9128.48 15674.7C9122.76 15673.4 9117.12 15677.1 9115.87 15682.8L9083.98 15829C9082.74 15834.7 9086.36 15840.4 9092.08 15841.6L9108.01 15845.1C9113.73 15846.4 9119.37 15842.7 9120.62 15837L9152.51 15690.8C9153.76 15685.1 9150.13 15679.4 9144.42 15678.2Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9225.9 15903L9233.08 15870.1L9198.91 15862.7L9191.73 15895.6C9184.73 15927.8 9172.13 15957.9 9154.25 15985.4L9182.72 16005.8C9203.28 15974.5 9217.94 15939.7 9225.92 15903H9225.9Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8798.17 15275.1L8791.43 15306.1L8838.16 15316.3L8844.91 15285.3L8798.17 15275.1Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8661.3 15245.3L8654.56 15276.2L8701.3 15286.4L8708.04 15255.5L8661.3 15245.3Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8524.48 15215.5L8517.73 15246.4L8564.47 15256.6L8571.22 15225.7L8524.48 15215.5Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8384.85 15185L8378.11 15216L8424.85 15226.2L8431.59 15195.2L8384.85 15185Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8250.76 15155.8L8244.02 15186.7L8290.76 15196.9L8297.5 15166L8250.76 15155.8Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7858.58 16507.6L7792.7 16493.2L7792.26 16495.2C7786.19 16523 7803.85 16550.5 7831.69 16556.6L7847.14 16560L7858.56 16507.6H7858.58Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8147.05 15197.9L8160.53 15136.1L8142.19 15132.1C8114.35 15126 8086.85 15143.7 8080.77 15171.5L8078.28 15182.9L8147.05 15197.9Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8935.02 15305L8928.28 15335.9L8975.02 15346.1L8981.76 15315.2L8935.02 15305Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8499.08 16647.3L8487.65 16699.8L8534.39 16709.9L8545.81 16657.5L8499.08 16647.3Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7951.64 16528L7940.21 16580.4L7986.95 16590.6L7998.37 16538.2L7951.64 16528Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9286.73 15381.6L9177.36 15357.7C9158.12 15446 9214.07 15533.1 9302.33 15552.3L9326.17 15443C9332.23 15415.1 9314.58 15387.6 9286.73 15381.5V15381.6Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8702.45 16691.5L8635.79 16677L8624.36 16729.4L8669.06 16739.1L8702.45 16691.5Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9056.12 15331.4L9049.38 15362.3L9096.12 15372.5L9102.86 15341.6L9056.12 15331.4Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8362.21 16617.5L8350.78 16669.9L8397.52 16680.1L8408.95 16627.7L8362.21 16617.5Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8085.75 16557.2L8074.32 16609.6L8121.06 16619.8L8132.48 16567.4L8085.75 16557.2Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8225.36 16587.7L8213.93 16640.1L8260.67 16650.3L8272.1 16597.8L8225.36 16587.7Z",
    stroke: "white",
    strokeWidth: 5.89258,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_25923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10573.8,
    height: 11642.1,
    fill: "white",
    transform: "translate(6186.69 14178) scale(0.624225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/Property.991cca06b92eb109fcdb0e1e90472ce7.svg";
export { ForwardRef as ReactComponent };